function Footer() {
    return (
        <div className='page-footer'>
            <div className="small-copy">
                These materials are provided to NORM members only.
            </div>
        </div>
    );
}

export default Footer;